import { Check } from "lucide-react";
import { passwordRequirementLabels } from "../../data/auth/createAccountPage";
import { authTheme } from "../../data/auth/authTheme";
import { passwordRequirementScore } from "../../utils/auth/evaluatePasswordRequirements";

export function PasswordRequirementsPanel({ requirements }) {
  const score = passwordRequirementScore(requirements);
  const total = Object.keys(requirements).length;
  const progress = (score / total) * 100;

  return (
    <div className="space-y-3">
      <div className="h-1.5 overflow-hidden rounded-full bg-[#E5E7EB]">
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{
            width: `${progress}%`,
            backgroundColor:
              score === total ? authTheme.success : authTheme.accent,
          }}
        />
      </div>
      <ul className="grid gap-2 sm:grid-cols-2">
        {Object.entries(requirements).map(([key, met]) => (
          <li key={key} className="flex items-center gap-2 text-sm">
            <span
              className={[
                "flex size-5 shrink-0 items-center justify-center rounded-full",
                met ? "bg-[#DCFCE7] text-[#16A34A]" : "bg-[#F3F4F6] text-[#9CA3AF]",
              ].join(" ")}
              aria-hidden
            >
              <Check className="h-3 w-3" />
            </span>
            <span style={{ color: met ? "#166534" : authTheme.muted }}>
              {passwordRequirementLabels[key]}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
